<template>
  <el-dialog
    :visible.sync="visible"
    :before-close="handleBeforeClose"
    @closed="closeEvent"
    :auto-close="true"
    :show-close="!disableClose"
    :close-on-click-modal="!disableClose"
    :close-on-press-escape="!disableClose"
  >
    <slot name="title"></slot>
    <el-row>
      <el-col class="mb-12" v-show="isJoin && !hideTotalLine">商品总数：{{totalNum}}款</el-col>
      <el-col class="mb-12">
        <el-progress :text-inside="true" :stroke-width="24" :percentage="percentageValue"></el-progress>
      </el-col>
      <el-col v-show="isJoinDistribute ? !isJoinDistribute : isJoin">
        {{ tipText || '收起之后可在“商品日志-商品新增”中查看' }}
      </el-col>
    </el-row>

    <div class="mt-20 mb-20" v-if="showLongTip">数据较多，可能会耽误您几分钟，请耐心等待下...</div>

    <span slot="footer" class="dialog-footer" v-show="!disableClose && ((isJoinDistribute ? !isJoinDistribute : isJoin) || showRetractBtn)">
      <el-button type="primary" @click="handleBeforeClose">收 起</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { queryScmJobResult } from '@api/prod/center/index.js'
import { prodQueryJobResult, getJoinDistributorItemResult } from "@/servers/prod/center";

export default {
  props: {
    percentage: {
      type: [String, Number],
      default: 0
    },
    propsTotalNum: {
      type: [String, Number],
      default: 0
    },
    isJoin: {
      type: Boolean,
      default: true
    },
    isJoinDistribute: {
      type: Boolean,
      default: false
    },
    isRealityProgress:{
      type: Boolean,
      default: false
    },
    showRetractBtn: {
      type: Boolean,
      default: false,
    },
    showLongTip: {
      type: Boolean,
      default: false,
    },
    disableClose: {
      type: Boolean,
      default: false,
    },
    hideTotalLine: {
      type: Boolean,
      default: false,
    },
    tipText: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      visible: false,
      percentageValue:  0,
      totalNum: 0,
      isDownForce: false,
      itemTotal: 0
    }
  },
  watch: {
    percentage: {
      handler(val) {
        // 直接使用后端返回的进度值
        this.percentageValue = Math.ceil(val)
      },
      immediate: true
    },
    propsTotalNum: {
      handler(val) {
        this.totalNum = Math.ceil(val)
      },
      immediate: true
    }
  },
  methods: {
    calculation_progress(total=1, percentage) {
			let tt = 1500 + (total * 200)
			let x = 2, y = 100/x, t = tt/y;
      // 如果使用真实滚动条，用上层业务传输过来的数据，假的才走else逻辑
      if(this.isRealityProgress){
        this.percentageValue = Math.ceil(percentage);
      }else{
        let time = setInterval(()=> {
          if(this.percentageValue >= 96) {
            clearInterval(time)
          }else {
              this.percentageValue += x;
          }
        }, t)
      }
      if(this.isJoin && total){
        this.totalNum = total;
      }
        
		},
    showDialog() {
      this.percentageValue = 0;
      this.totalNum = 0;
      this.isDownForce = false;
      this.visible = true;
    },
    /**
     * 弹窗关闭前置拦截（用户主动关闭、收起）
     */
    handleBeforeClose() {
      if (this.disableClose) {
        return;
      }
      this.handleClose();
    },
    handleClose() {
      this.visible = false;
      this.isDownForce = true;
    },
    closeEvent() {
      this.$emit('close');
    },
    // 从平台下载，从erp导入的查询结果接口
    queryScmJobResult(type, callbackFn) {
      if(this.isDownForce) return;
      let formdata = new FormData();
      formdata.append('taskTypeEnum', type);
      queryScmJobResult(formdata).then((res) => {
        /**
         * 后端返回的totalNum是所有sku的数量，产品要计算后的spu的数量，后端通过totalNumSpu返回spu的数量。
         * 若totalNumSpu无值，选取totalNum
         * 以上逻辑是根据之前只有sku，没有按款TAB逻辑，现在的total数量就是选择的商品总数
         */
        let totalNum = res.data.result.totalNum || 0;
        // let totalNumSpu = res.data.result?.totalNumSpu;
        // if(totalNumSpu || totalNumSpu===0){
        //   this.totalNum = totalNumSpu;
        // }else{
          this.totalNum = totalNum
        // }
        
        if (res.data.finished) {
          this.percentageValue = 100
          this.visible = false
        } else {
          setTimeout(() => {
            this.queryScmJobResult(type, callbackFn)
          }, 1000)
        }
        callbackFn(res.data);
      })
    },
    // 从分销商端的分销商品、供销商展架导入商品的查询结果接口
    queryJobResult(params, callbackFn) {
      if(this.isDownForce) return;
      prodQueryJobResult(params).then((res) => {
        this.totalNum = res.result.totalNum || 0;
        if (res.finished) {
          this.percentageValue = 100
          this.visible = false
        } else {
          setTimeout(() => {
            this.queryJobResult(params, callbackFn)
          }, 1000)
        }
        callbackFn(res);
      })
    },
    // 获取加入分销商品的结果
    fetch_joinDistributorItemResult(params, callbackFn) {
      if(this.isDownForce) return;
      getJoinDistributorItemResult(params).then((res) => {
        console.log('%c [ res ]-194', 'font-size:13px; background:pink; color:#bf2c9f;', res)
        this.totalNum = res.result.totalNum || 0;
        // 使用后端返回的 loading 字段
        if (res?.loading !== undefined) {
          this.percentageValue = Math.ceil(res.loading)
        } else {
          this.percentageValue = 0;
        }
        if (res.finished) {
          this.percentageValue = 100
          this.visible = false
        } else {
          setTimeout(() => {
            this.fetch_joinDistributorItemResult(params, callbackFn)
          }, 1000)
        }
        callbackFn(res);
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.mb-12{
  margin-bottom: 12px;
}
.mb-40{
  margin: 40px 0;
}

</style>
